import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';
import classNames from 'classnames';

import Link from '~/shared/components/link';

import './read-more-link.scss';

type ReadMoreLinkPropsType = {};

const ReadMoreLink = ({ content, className, href }: ReadMoreLinkPropsType) => {
  return (
    <Link itemProp="url" href={href} className={classNames('read-more-link', className)}>
      {content}
      <HiChevronRight className="read-more-link__circle-chevron" />
    </Link>
  );
};

export default ReadMoreLink;
